import Link from 'next/link';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { formatChatDate, isChatReceiver } from '../../../utils/chatUtils';
import { PROFILE_ROUTE } from '../../../utils/routes';
import Avatar from '../Common/Avatar/Avatar';
import HTMLRenderer from '../Common/HTMLRenderer/HTMLRenderer';
import { useSelector } from 'react-redux';

const MdOutlineVerified = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineVerified)
);
const MdStar = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdStar)
);

const ChatListItem = ({ data }) => {
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();
  const { profile_id, city } = router?.query;
  const selectedCity = useSelector(({ cities }) => cities?.selectedCity);
  return (
    <div className='flex w-full  gap-2 border-b px-2 py-3'>
      {/* <div className="w-[48px] h-[48px] rounded-full bg-gray-400 relative">
        <div className="w-2 h-2 rounded-full bg-green-600 mr-1 absolute bottom-1 right-0 border border-white"></div>
      </div> */}
      <div className='h-[48px] w-[48px]'>
        <Avatar
          width='w-[48px]'
          height='h-[48px]'
          imagePath={data?.profile_img?.path || ''}
          userName={data?.name}
        />
      </div>
      <div className='w-full pr-[4px]'>
        <div className='flex items-center justify-between text-[16px] font-normal text-black'>
          {data?.profile_id == profile_id ? (
            <Link
              className='flex items-center gap-3'
              href={PROFILE_ROUTE({
                userId: data?.user_public_id,
                profileId: data?.profile_public_id,
                city,
              })}
              target='_blank'
            >
              <div className='max-w-[220px] truncate'>{data?.name} </div>
              {data?.is_verified == 1 ? <MdOutlineVerified /> : null}
            </Link>
          ) : (
            <div className='flex flex-1 items-center gap-3'>
              <div className='max-w-[220px] truncate'>{data?.name} </div>
              {data?.is_verified == 1 ? <MdOutlineVerified /> : null}
            </div>
          )}
          {data?.is_favorite == 1 && (
            <div className='flex items-center gap-2'>
              {/* <div className="w-2 h-2 rounded-full bg-red-600 mr-1"></div> */}
              <MdStar color='#FAA61A' />
            </div>
          )}
        </div>
        <div className='text-gray-[#808080] text-truncate flex w-full items-center justify-between text-sm sm:w-[320px]'>
          <div className='mt-1 line-clamp-1 w-[200px] truncate sm:w-[220px]'>
            {' '}
            {data?.last_message === 'this_is_a_file' ? (
              `${lang?.common?.this_is_a_file}`
            ) : (
              <HTMLRenderer html={data?.last_message} />
            )}
          </div>

          {data?.last_message_time && (
            <div className='flex flex-col items-end gap-[8px]'>
              {!data?.is_seen && isChatReceiver(data?.receiver_profile_id) && (
                <div className='mr-1 h-2 w-2 rounded-full bg-indicator-red'></div>
              )}
              <div className='flex items-center truncate text-xs'>
                <div className='mr-1 h-1 w-1 rounded-full bg-gray-400'></div>
                <div>
                  {formatChatDate(data?.last_message_time, selectedCity?.id)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatListItem;
